import { render, staticRenderFns } from "./AdminUser.vue?vue&type=template&id=38b781ba&scoped=true&"
import script from "./AdminUser.vue?vue&type=script&lang=js&"
export * from "./AdminUser.vue?vue&type=script&lang=js&"
import style0 from "./AdminUser.vue?vue&type=style&index=0&id=38b781ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b781ba",
  null
  
)

export default component.exports